import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/our_people";

export default class OurPeople extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Our People | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
